/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable max-statements */

import { VpsProvider } from '@wemap/providers';

export default async function checkArNavParams(snippet) {
    const { arviewenabled, arswitcherbutton, arnavigationdata } = snippet;

    const messages = [];

    if (!arviewenabled) {
        messages.push({
            variant: 'warning',
            message: (
                <>
                    AR disabled on this map. To enable it, please use:{' '}
                    <i>arviewenabled: true</i>.
                </>
            )
        });
        return messages;
    }

    const context = arnavigationdata?.default || 'outdoor';
    messages.push({
        variant: 'success',
        message: (
            <>
                AR is <strong>enabled</strong> and configuration is{' '}
                <strong>{context}</strong>.
                <br />
                AR radius is{' '}
                <strong>{arnavigationdata?.arRadius || 1000} meters</strong>.
            </>
        )
    });

    const providers = arnavigationdata?.providers;
    if (!providers?.blacklist?.length && !providers?.whitelist?.length) {
        messages.push({
            variant: 'info',
            message: (
                <>
                    <strong>Default providers</strong> are used for positioning (GnssWifi,
                    Compass, Accelerometer, Gyroscope)
                </>
            )
        });
    } else {
        const blacklist = providers?.blacklist || [];
        const whitelist = providers?.whitelist || [];
        if (whitelist.includes(VpsProvider.pname)) {
            if (!providers?.vps?.endpoint) {
                messages.push({
                    variant: 'danger',
                    message: (
                        <>
                            Vps is enabled on the map but{' '}
                            <strong>endpoint is not defined</strong>.
                        </>
                    )
                });
            } else {
                const { vps } = providers;
                const reg = (/https:\/\/vps-api.maaap.it\/(.*)\/geopose/).exec(
                    vps.endpoint
                );
                const vpsMap = reg === null ? null : reg[1];
                if (!vpsMap) {
                    messages.push({
                        variant: 'danger',
                        message: (
                            <>
                                Vps is enabled on the map but{' '}
                                <strong>endpoint url is wrong</strong>.
                            </>
                        )
                    });
                } else {
                    // TODO: Add VPS server online check
                    const useCoarsePose = !('useCoarsePose' in vps)
                        ? true
                        : vps.useCoarsePose;
                    const vpsServersStatus = await (
                        await fetch('https://vps-api.maaap.it/geopose/status')
                    ).json();

                    const vpsMapStatus = vpsServersStatus.find(({ id }) => id === vpsMap);
                    if (!vpsMapStatus) {
                        messages.push({
                            variant: 'danger',
                            message: (
                                <>
                                    Vps map <strong>{vpsMap}</strong> is <strong>unknown</strong>{' '}
                                    on the VPS server.
                                </>
                            )
                        });
                    } else if (vpsMapStatus.status !== 0) {
                        messages.push({
                            variant: 'danger',
                            message: (
                                <>
                                    Vps is enabled and well configured but{' '}
                                    <strong>the server is stopped</strong>.<br />
                                    Map used: <strong>{vpsMap}</strong>.
                                </>
                            )
                        });
                    } else {
                        messages.push({
                            variant: 'success',
                            message: (
                                <>
                                    <strong>Vps is enabled</strong> and the{' '}
                                    <strong>server is started</strong>.<br />
                                    Map used: <strong>{vpsMap}</strong>.<br />
                                    Coarse pose is {useCoarsePose ? 'enabled' : 'disabled'}.
                                </>
                            )
                        });
                    }
                }
            }
        }
        if (whitelist.includes('QRCode')) {
            messages.push({
                variant: 'success',
                message: (
                    <>
                        <strong>QRCode scanner is enabled</strong>.
                    </>
                )
            });
        }
        if (blacklist.length) {
            messages.push({
                variant: 'warning',
                message: (
                    <>
                        Following providers are <strong>disabled</strong>:{' '}
                        {blacklist.join(', ')}.
                    </>
                )
            });
        }
    }

    messages.push({
        variant: arswitcherbutton ? 'success' : 'info',
        message: (
            <>
                arswitcherbutton is{' '}
                <strong>{arswitcherbutton ? 'enabled' : 'disabled'}</strong>.
            </>
        )
    });

    messages.push({
        variant: arnavigationdata?.audio ? 'success' : 'info',
        message: (
            <>
                audio instructions are{' '}
                <strong>{arnavigationdata?.audio ? 'enabled' : 'disabled'}</strong>.
            </>
        )
    });

    const mapFormMMNetwork = arnavigationdata?.[context]?.mapmatching?.network;
    if (mapFormMMNetwork) {
        const knownMaps = await (
            await fetch('https://routing.getwemap.com/v3/list')
        ).json();
        if (knownMaps.includes(mapFormMMNetwork)) {
            messages.push({
                variant: 'success',
                message: (
                    <>
                        MapMatching on network is <strong>enabled</strong> on map{' '}
                        <strong>{mapFormMMNetwork}</strong>.
                    </>
                )
            });
        } else {
            messages.push({
                variant: 'danger',
                message: (
                    <>
                        MapMatching on network is <strong>enabled</strong> but the map{' '}
                        <strong>{mapFormMMNetwork} does not exist</strong> in the meta
                        router list.
                    </>
                )
            });
        }
    } else {
        messages.push({
            variant: 'info',
            message: (
                <>
                    MapMatching on network is <strong>disabled</strong>
                </>
            )
        });
    }

    const accuracyThreshold = arnavigationdata?.[context]?.accuracyThreshold;
    if (
        context === 'indoor'
    && typeof accuracyThreshold !== 'undefined'
    && accuracyThreshold !== 8
    ) {
        messages.push({
            variant: 'warning',
            message: (
                <>
                    Accuracy Threshold is <strong>{accuracyThreshold} meters</strong>.
                    Default is 8 meters.
                </>
            )
        });
    }

    if (
        context === 'outdoor'
    && typeof accuracyThreshold !== 'undefined'
    && accuracyThreshold !== 25
    ) {
        messages.push({
            variant: 'warning',
            message: (
                <>
                    Accuracy Threshold is <strong>{accuracyThreshold} meters</strong>.
                    Default is 8 meters.
                </>
            )
        });
    }

    return messages;
}
